import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Interest_container = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const navigate = useNavigate();
  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value);
  };
  console.log(selectedOption);

  useEffect(() => {
    navigate(selectedOption);
  }, [selectedOption]);
  return (
    <section className="interest-container">
      <div className="page-wrap row">
        <div className="col-12">
          <span
            className="label wow fadeInLeft duration animated"
            data-wow-duration="500ms"
            data-wow-delay="300ms"
          >
            I am interested in:
          </span>
          {/* <span
            className="wow fadeInDown duration animated"
            data-wow-duration="500ms"
            data-wow-delay="300ms"
          >
            <select name="select1" id="select1" className="custom-select">
              <option value="Topic" selected>
                Topic
              </option>
              <option value="1">CX Strategy</option>
              <option value="2">CRM Consulting</option>
              <option value="3">Digital Transformation</option>
              <option value="4">Operational Excellence</option>
              <option value="5">Experience Economy</option>
              <option value="6">Joining Virtuos</option>
            </select>
          </span> */}
          <span
            className="wow fadeInDown duration animated"
            data-wow-duration="500ms"
            data-wow-delay="300ms"
          >
            <select name="select3" id="select3" className="custom-select">
              <option value="Topic" selected>
                Topic
              </option>
              <option value="1">CX Strategy</option>
              <option value="2">CRM Consulting</option>
              <option value="3">Digital Transformation</option>
              <option value="4">Operational Excellence</option>
              <option value="5">Experience Economy</option>
              <option value="6">Joining Virtuos</option>
            </select>
          </span>
          {/* <span
            className="wow fadeInDown duration animated"
            data-wow-duration="500ms"
            data-wow-delay="300ms"
          > */}
          <select
            name="select4"
            id="select4"
            className="custom-select wow fadeInDown duration animated"
            data-wow-duration="500ms"
            data-wow-delay="300ms"
            value={selectedOption}
            onChange={handleSelectChange}
          >
            {/* <option value="" selected>Business 4.0</option> */}
            <option value="">Business 4.0</option>

            {/* <option value="cx/strategy-design/">CX Strategy Overview</option>
              <option value="consultare/crm-cx/#portfolio">
                CRM and CX Portfolio
              </option>
              <option value="cxnow">CXNow Program</option>
              <option value="cxnow/cxprism/">CX Design Thinking</option> */}

            <option value="/crm-digital/">CRM Digital Overview</option>
            <option value="/crm-digital/sales/">CRM Sales</option>
            <option value="/crm-digital/service/">CRM Service</option>
            <option value="/crm-digital/marketing/">CRM Marketing</option>
            <option value="/crm-digital/commerce/">CRM Commerce</option>
            <option value="/consultare/professional-services/">
              CRM Professional Services
            </option>

            {/* <option value="cxnow/">CXNow Program</option>
              <option value="cxnow/customer-voice/">
                Voice of the Customer
              </option>
              <option value="c-digital/">CRM Mastermind</option>
              <option value="cloud/">Cloud Mastermind</option>
              <option value="indicial/">Indicial Digital maturity</option>
              <option value="w-digital/">Digital Workplace</option>

              <option value="vivacis/">Vivacis Digital Automation</option>
              <option value="o-digital/">O.Digital Operations</option>
              <option value="cxdesk/">CXDESK Program</option>
              <option value="consultare/engineering-services/">
                Digital Engineering
              </option>

              <option value="exonomy/">Xonomy overview</option>
              <option value="salesforce/">Salesforce Xonomy</option>
              <option value="experience-cloud/">Experience Cloud</option>
              <option value="experience-crowd/">Experience Crowd</option>
              <option value="io/">Innovation Open</option>

              <option value="corporate/">About Virtuos</option>
              <option value="careers/culture/">Virtuos Culture</option>
              <option value="careers/jobs/">Current Opportunities</option>
              <option value="careers/experience-job/">ExperienceJob</option> */}
          </select>
          {/* </span> */}
        </div>
      </div>
    </section>
  );
};

export default Interest_container;
